import React, { Component } from 'react';
//const img_path = 'https://www.kinshipliving.com/images/uploads/kinship/organizers/';
import avatar from '../../../assets/images/avatar.png';


export default class UserListPage extends Component {
    // constructor(props) {
    //     super(props)


    // }

    render() {
        return (
            <div>
            { /* 
            <div class="form-back-link" onClick={() => this.props.HandleRouting('home')}>
                    <i class="fa fa-arrow-left" aria-hidden="true"></i>
                    <a>Back</a>
                </div>
            */  }
                <div class="all-users-list-main">
                    <div class="container-fluid">
                        <h3>Users</h3>

                        <div class="users-list-div">
                            <div class="row">
                                <div class="col-md-12 col-lg-12 organizers-head-list-desktop">
                                    <div class="row">
                                        <div class="col-md-1 col-lg-1">
                                            <div class="users-list-head">
                                                <h5>Sr.No.</h5>
                                            </div>
                                        </div>
                                        <div class="col-md-2 col-lg-2">
                                            <div class="users-list-head">
                                                <h5>FullName</h5>
                                            </div>
                                        </div>
                                        <div class="col-md-2 col-lg-2">
                                            <div class="users-list-head">
                                                <h5>Mobile Number</h5>
                                            </div>
                                        </div>
                                        <div class="col-md-2 col-lg-2">
                                            <div class="users-list-head">
                                                <h5>User Email</h5>
                                            </div>
                                        </div>
                                        <div class="col-md-1 col-lg-1">
                                            <div class="users-list-head">
                                                <h5>Status</h5>
                                            </div>
                                        </div>
                                        <div class="col-md-2 col-lg-2">
                                            <div class="users-list-head">
                                                <h5>Date of Birth</h5>
                                            </div>
                                        </div>
                                        <div class="col-md-2 col-lg-2">
                                            <div class="users-list-head">
                                                <h5>Last Login</h5>
                                            </div>
                                        </div>


                                    </div>

                                </div>

                                {this.props.userlist.length > 0 ?

                                    this.props.userlist.map((item, i) => (

                                        <div class="col-md-12 col-lg-12 organizers-list-desktop">
                                            <div class="users-list-details">
                                                <div class="row">
                                                    <div class="col-md-1 col-lg-1">
                                                        <div class="users-list-content">
                                                            <p>{i + 1}</p>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2 col-lg-2">
                                                        <div class="users-list-content">
                                                            <p>{item.user_full_name}</p>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2 col-lg-2">
                                                        <div class="users-list-content">
                                                            <p>{item.user_mobile}</p>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2 col-lg-2">
                                                        <div class="users-list-content">
                                                            <p>{item.user_email}</p>
                                                        </div>
                                                    </div>
                                                    {item.user_status === '1' ?
                                                        <div class="col-md-1 col-lg-1">
                                                            <div class="users-list-content">
                                                                <p>Active</p>
                                                            </div>
                                                        </div>
                                                        :

                                                        <div class="col-md-1 col-lg-1">
                                                            <div class="users-list-content">
                                                                <p>Inactive</p>
                                                            </div>
                                                        </div>
                                                    }
                                                    <div class="col-md-2 col-lg-2">
                                                        <div class="users-list-content">
                                                            <p>{item.user_dob}</p>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2 col-lg-2">
                                                        <div class="users-list-content">
                                                            <p>{item.last_login}</p>
                                                        </div>
                                                    </div>

                                                </div>



                                            </div>

                                        </div>

                                        

                                    ))


                                    : ''}

                                    
                                {this.props.userlist.length > 0 ?

                                    this.props.userlist.map((item, i) => (

                                        <div class="col-md-12 col-lg-12 organizers-list-mobile">
                                            <div class="users-list-details">
                                                <div class="row">
                                                <div class="col-4 col-md-1 col-lg-1">
                                                <div class="users-list-content-img">
        
                                                    <img src={avatar} alt='loading...'/>
                                                </div>
                                            </div>
                                                   
                                                    <div class="col-8 col-md-2 col-lg-2">
                                                        <div class="users-list-content">
                                                            <p>{item.user_full_name}</p>
                                                        </div>
                                                        <div class="users-list-content">
                                                        <p>{item.user_email}</p>
                                                    </div>
                                                        <div class="users-list-content">
                                                        <p>{item.user_mobile}</p>
                                                    </div>
                                                    {item.user_status === '1' ?
                                                   
                                                    <div class="custom-control custom-checkbox">
                                                    <input type="checkbox" class="custom-control-input" id="defaultCheckedDisabled2" checked disabled/>
                                                    <label style={{color:'black'}} class="custom-control-label" for="defaultCheckedDisabled2">Active</label>
                                                  </div>
                                                   
                                                    :

                                                   
                                                    <div class="custom-control custom-checkbox">
                                                    <input type="checkbox" class="custom-control-input" id="defaultUncheckedDisabled2" disabled/>
                                                    <label class="custom-control-label" for="defaultUncheckedDisabled2">Active</label>
                                                  </div>
                                                   
                                                }
                                                    </div>
                                                   
                                                  
                                                  
                                                  

                                                </div>



                                            </div>

                                        </div>

                                        

                                    ))


                                    : ''}


                            </div>

                        </div>
                    </div>

                </div>

            </div>
        )
    }
}